export const normalizeCollection = (data) => {
  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.data)) {
    return data.data;
  }

  return [];
};

export const normalizePersonId = (personId) => {
  const numericId = Number(personId);
  return Number.isNaN(numericId) ? personId : numericId;
};

export const resolvePersonLabel = (person) =>
  person?.full_name ||
  person?.displayname ||
  person?.name ||
  person?.mail ||
  person?.email ||
  person?.login ||
  `${person?.person_id}`;

export const resolveSubjectTypeLabel = (subjectType, t) =>
  subjectType === 'elective' ? t('Výberový predmet') : t('Povinný predmet');

export const resolveCompletionTypeLabel = (completionType, t) => {
  const labels = {
    S: 'Skúška',
    T: 'Štátna skúška',
    V: 'Absolvovanie',
  };

  return labels[completionType] ? t(labels[completionType]) : undefined;
};
